import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.754 7.55a4.249 4.249 0 1 0-8.208 2.2 4.249 4.249 0 0 0 8.208-2.2M7.188 3.194a5.649 5.649 0 0 1 5.92 8.925l3.687 3.686a.7.7 0 1 1-.99.99L12.12 13.11a5.649 5.649 0 1 1-4.931-9.916"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
